module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pops', {
    attrs: {
      "show": _vm.popDetail,
      "title": '病例详情',
      "width": '60%'
    },
    on: {
      "closePop": _vm.closePopDetail
    }
  }, [_c('div', {
    staticClass: "popScore carsePop"
  }, [_c('div', {
    staticClass: "popContent detailCont popTxt"
  }, [_c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("病例名称：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(this.medicDetail.caseName))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("病例分类：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.typeName))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(this.medicDetail.caseSex))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("年龄：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(this.medicDetail.caseAge))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row changeHeight"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("患者病史：")]), _vm._v(" "), _c('span', {
    staticClass: "content disContent",
    staticStyle: {
      "line-height": "20px"
    }
  }, [_vm._v(_vm._s(this.medicDetail.history))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row changeHeight"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("影像所见：")]), _vm._v(" "), _c('span', {
    staticClass: "content disContent",
    staticStyle: {
      "line-height": "20px"
    }
  }, [_vm._v(_vm._s(this.medicDetail.evidence))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row changeHeight"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("诊断结果：")]), _vm._v(" "), _c('span', {
    staticClass: "content disContent",
    staticStyle: {
      "line-height": "20px"
    }
  }, [_vm._v(_vm._s(this.medicDetail.dianogeResult))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row changeHeight"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("病理结果：")]), _vm._v(" "), _c('span', {
    staticClass: "content disContent",
    staticStyle: {
      "line-height": "20px"
    }
  }, [_vm._v(_vm._s(this.medicDetail.caseResult))])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-63f744a9","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/pops/casePop.vue
// module id = 574
// module chunks = 1 2 3 4 5 6 7 8